import { render, staticRenderFns } from "./Abwesenheiten.vue?vue&type=template&id=3142d12b&scoped=true"
import script from "./Abwesenheiten.vue?vue&type=script&lang=ts"
export * from "./Abwesenheiten.vue?vue&type=script&lang=ts"
import style0 from "./Abwesenheiten.vue?vue&type=style&index=0&id=3142d12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142d12b",
  null
  
)

export default component.exports